var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99933 3.25C7.41354 3.25 7.74933 3.58579 7.74933 4V5.66763C10.5771 5.4158 13.4216 5.4158 16.2493 5.66763V4C16.2493 3.58579 16.5851 3.25 16.9993 3.25C17.4135 3.25 17.7493 3.58579 17.7493 4V5.81644C19.2424 6.02754 20.4219 7.20847 20.6216 8.71484L20.7081 9.36779C21.0722 12.1141 21.0407 14.8984 20.6148 17.6359C20.4037 18.9919 19.3021 20.0335 17.9363 20.1681L16.7433 20.2858C13.5883 20.5969 10.4103 20.5969 7.25525 20.2858L6.06225 20.1681C4.69651 20.0335 3.59485 18.9919 3.38384 17.6359C2.95788 14.8984 2.92644 12.1141 3.29048 9.36779L3.37703 8.71484C3.57671 7.20845 4.75626 6.02751 6.24933 5.81643V4C6.24933 3.58579 6.58511 3.25 6.99933 3.25ZM7.44449 7.2028C10.4737 6.90408 13.5249 6.90408 16.5541 7.2028L17.4596 7.2921C18.3263 7.37757 19.0201 8.04854 19.1346 8.91194L19.2211 9.56489C19.2514 9.793 19.2787 10.0214 19.3032 10.25H4.69539C4.71987 10.0214 4.74723 9.79301 4.77747 9.5649L4.86402 8.91194C4.97847 8.04854 5.67229 7.37757 6.53904 7.2921L7.44449 7.2028ZM4.57616 11.75C4.47798 13.6381 4.57471 15.5332 4.866 17.4052C4.97184 18.0854 5.52442 18.6078 6.20946 18.6754L7.40246 18.793C10.4596 19.0945 13.539 19.0945 16.5961 18.793L17.7891 18.6754C18.4742 18.6078 19.0268 18.0854 19.1326 17.4052C19.4239 15.5332 19.5206 13.6381 19.4224 11.75H4.57616Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.73d53e845e389a1fccc949879c2e871a.svg";
export { ForwardRef as ReactComponent };